/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Increment_QuantityInputs */

const en_admin_external_booking_edit_increment_quantity = /** @type {(inputs: Admin_External_Booking_Edit_Increment_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Increase quantity`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Increment_QuantityInputs) => LocalizedString} */
const de_admin_external_booking_edit_increment_quantity = en_admin_external_booking_edit_increment_quantity;

/** @type {(inputs: Admin_External_Booking_Edit_Increment_QuantityInputs) => LocalizedString} */
const es_admin_external_booking_edit_increment_quantity = en_admin_external_booking_edit_increment_quantity;

/** @type {(inputs: Admin_External_Booking_Edit_Increment_QuantityInputs) => LocalizedString} */
const fr_admin_external_booking_edit_increment_quantity = en_admin_external_booking_edit_increment_quantity;

/** @type {(inputs: Admin_External_Booking_Edit_Increment_QuantityInputs) => LocalizedString} */
const it_admin_external_booking_edit_increment_quantity = en_admin_external_booking_edit_increment_quantity;

/** @type {(inputs: Admin_External_Booking_Edit_Increment_QuantityInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_increment_quantity = en_admin_external_booking_edit_increment_quantity;

/** @type {(inputs: Admin_External_Booking_Edit_Increment_QuantityInputs) => LocalizedString} */
const pl_admin_external_booking_edit_increment_quantity = en_admin_external_booking_edit_increment_quantity;

/** @type {(inputs: Admin_External_Booking_Edit_Increment_QuantityInputs) => LocalizedString} */
const hu_admin_external_booking_edit_increment_quantity = en_admin_external_booking_edit_increment_quantity;

/** @type {(inputs: Admin_External_Booking_Edit_Increment_QuantityInputs) => LocalizedString} */
const ro_admin_external_booking_edit_increment_quantity = en_admin_external_booking_edit_increment_quantity;

/**
* | output |
* | --- |
* | "Increase quantity" |
*
* @param {Admin_External_Booking_Edit_Increment_QuantityInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_increment_quantity = /** @type {((inputs?: Admin_External_Booking_Edit_Increment_QuantityInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Increment_QuantityInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_increment_quantity(inputs)
	if (locale === "de") return de_admin_external_booking_edit_increment_quantity(inputs)
	if (locale === "es") return es_admin_external_booking_edit_increment_quantity(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_increment_quantity(inputs)
	if (locale === "it") return it_admin_external_booking_edit_increment_quantity(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_increment_quantity(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_increment_quantity(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_increment_quantity(inputs)
	return ro_admin_external_booking_edit_increment_quantity(inputs)
});
export { admin_external_booking_edit_increment_quantity as "admin.external_booking_edit.increment_quantity" }